import { Form, Input, Row, Col, Button } from 'antd';
import './style.scss';
import json5 from 'json5';

const ShoppablePanel = ({ storylyRef }) => {
  return (
    <div className="shoppable-panel">
      <h6>Product Hydration</h6>
      <Form.Item
        label="Product ID's"
        style={{ marginBottom: 12 }}
        name="productIds"
      >
        <Input.TextArea rows={4} disabled />
      </Form.Item>
      <Row gutter={12}>
        <Col span={24}>
          <Form.Item
            label="Hydration Input"
            name="productHydrationInput"
            style={{ marginBottom: 12 }}
          >
            <Input.TextArea placeholder="Enter Hydration Input" rows={4} />
          </Form.Item>
        </Col>
        <Col span={24} flex="none">
          <Form.Item noStyle dependencies={['productHydrationInput']}>
            {({ getFieldValue }) => {
              const hydration = getFieldValue('productHydrationInput');

              return (
                <Button
                  onClick={() => {
                    storylyRef?.current?.setStorylyHydration(
                      json5.parse(hydration)
                    );
                  }}
                  type="primary"
                  style={{ marginBottom: 12 }}
                >
                  Apply Hydration
                </Button>
              );
            }}
          </Form.Item>
        </Col>
      </Row>
      <h6>Client Side Automation</h6>
      <Form.Item label="Story Group Client Side Products" name="productFeed">
        <Input.TextArea placeholder="Enter Client Side Products" rows={4} />
      </Form.Item>
    </div>
  );
};

export default ShoppablePanel;
